import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'

import { IResultado } from '../../../Interfaces/IResultado';
import control from '../../ModalLlenarPesosResultado/constants'
import UploadVideoSection from '../EvaluacionComponents/UploadVideoSection';
// import { resultadoService } from '../../../Services/Form';
// import { IUserFromStorage } from '../../../Interfaces/IUser';


interface IProps {
  isOpen : boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dataRes: IResultado;
}

const UploadVideoEvaluation = ({isOpen, setIsOpen, dataRes} : IProps) => {

  // const [isLoading, setIsLoading] = useState<boolean>(true);

  return (
    <>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative" style={{overflow: 'auto'}} fullScreen>
        <DialogTitle className="flex flex-row justify-around" style={{ fontWeight: 'bold' }}>

          <p className="text-xl m-0">{dataRes ? control[dataRes.mes - 1]?.titulo || control[0].titulo : control[0].titulo}</p>

        </DialogTitle>

        <DialogContent className="flex flex-col">
          <p className='self-center' id='Evaluation'>{dataRes ? control[dataRes.mes - 1]?.desc || control[0].desc : control[0].desc}</p>

          <a href="#Evaluation" id='GoToTheTop'></a>

          <UploadVideoSection />

        </DialogContent>
      </Dialog> 
    </>
  )
}

export default UploadVideoEvaluation